import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { selectStyle } from "../../../shared/fixtures/select_style";
import {
  CitySelect,
  CountrySelect,
  DarkFormField,
  DarkTextArea,
  SearchSelect,
  StateSelect,
} from "../../atoms/Inputs";
import { PhoneType, PhoneExt, Language } from "../../atoms/Inputs";
import { P } from "../../atoms/Texts";

const ErrorWrapper = ({ name, children }) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div>
      {children}
      {errors[name]?.message && (
        <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
          {errors[name]?.message}
        </P>
      )}
    </div>
  );
};

const FormField = ({ field, control }) => {
  // Basic input types
  if (["text", "email", "tel", "date", "number"].includes(field.type)) {
    return (
      <Controller
        name={field.name}
        control={control}
        rules={field.validation}
        render={({ field: formField }) => (
          <DarkFormField {...formField} {...field} className="w-full" />
        )}
      />
    );
  }

  // Textarea
  if (field.type === "textarea") {
    return (
      <Controller
        name={field.name}
        control={control}
        rules={field.validation}
        render={({ field: formField }) => (
          <DarkTextArea rows={3} {...formField} {...field} className="w-full" />
        )}
      />
    );
  }

  // Select components mapping
  const selectComponents = {
    PhoneExtension: PhoneExt,
    PhoneType,
    Language,
    Country: CountrySelect,
    State: StateSelect,
    City: CitySelect,
  };

  if (field.type in selectComponents) {
    const SelectComponent = selectComponents[field.type];
    return (
      <Controller
        name={field.name}
        control={control}
        rules={field.validation}
        render={({ field: formField }) => (
          <SelectComponent
            {...formField}
            {...field}
            control={control}
            styles={selectStyle}
          />
        )}
      />
    );
  }

  // Search select types
  const searchSelectTypes = [
    "Deductibility",
    "EO_Subsection",
    "Asset_Amount",
    "Income_Code",
    "Filing_Requirements",
    "Affiliation",
    "Select",
  ];

  if (searchSelectTypes.includes(field.type)) {
    return (
      <Controller
        name={field.name}
        control={control}
        rules={field.validation}
        render={({ field: formField }) => (
          <SearchSelect
            {...formField}
            {...field}
            control={control}
            styles={selectStyle}
          />
        )}
      />
    );
  }

  return <div>{`Can't render field (${field.name}:${field.type})`}</div>;
};

export const FormBuilder = ({ fields }) => {
  const { control } = useFormContext();

  return (
    <>
      {fields.map((field) => (
        <ErrorWrapper key={field.name} name={field.name}>
          <FormField field={field} control={control} />
        </ErrorWrapper>
      ))}
    </>
  );
};
